import { text_mod_39, } from "../text/Text.js";
export const module39 = {
  title:
    "Літера Ї велика",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_39,
    },
  ]
};